import { Graph, GraphData } from 'dashboard/models/graph';
import { GraphActions, GraphActionType } from 'dashboard/redux/actions/graph';

export interface GraphState {
  graph: Graph | undefined;
  graphs: Graph[] | undefined;
  graphData: GraphData | undefined;
  requestId: string | null | undefined;
}

export const initialGraphState: GraphState = {
  graph: undefined,
  graphs: undefined,
  graphData: undefined,
  requestId: undefined,
};

export default (state: GraphState = initialGraphState, action: GraphActions) => {
  switch (action.type) {
    case GraphActionType.SetGraph: {
      return {
        ...state,
        graph: action.payload.graph,
      };
    }

    case GraphActionType.SetGraphs: {
      return {
        ...state,
        graphs: action.payload.graphs,
      };
    }

    case GraphActionType.ClearGraphData: {
      return {
        ...state,
        graphData: undefined,
      };
    }

    case GraphActionType.SetGraphData: {
      return {
        ...state,
        graphData: action.payload.graphData,
      };
    }

    default:
      return state;
  }
};
